module.exports = __webpack_public_path__ + "img/cuotas-y-minimos.svg";